var _defs, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgImportImageBleu(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Calque_1",
    "data-name": "Calque 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 150 100.01",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: none;\n        stroke: #4970b6;\n        stroke-linecap: round;\n        stroke-linejoin: round;\n        stroke-width: 1.81px;\n      }\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M99.7,27.36c1.13,0,2.06.93,2.06,2.06v41.14l-.64-.84-17.5-22.64c-.58-.76-1.49-1.2-2.44-1.2s-1.85.44-2.44,1.2l-10.68,13.82-3.92-5.49c-.58-.81-1.51-1.29-2.51-1.29s-1.93.48-2.51,1.3l-10.29,14.41-.58.8V29.42c0-1.13.93-2.06,2.06-2.06h49.4ZM50.3,21.19c-4.54,0-8.23,3.69-8.23,8.23v41.17c0,4.54,3.69,8.23,8.23,8.23h49.4c4.54,0,8.23-3.69,8.23-8.23V29.42c0-4.54-3.69-8.23-8.23-8.23h-49.4ZM60.59,45.89c3.41,0,6.18-2.76,6.18-6.18s-2.76-6.18-6.18-6.18-6.18,2.76-6.18,6.18,2.76,6.18,6.18,6.18Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgImportImageBleu);
export default __webpack_public_path__ + "static/media/import_image_bleu.b47b7cc3c31164b30db67f604d7e92f2.svg";
export { ForwardRef as ReactComponent };